import { useEffect, useState } from 'react';

import { listSectionFilters } from '../../../services';
import { SECTION_FALLBACK_FILTERS } from '../../../shared/constants/sectionFallback.js';

const EMPTY = Object.freeze([]);

/** One request per session: the slideout is always mounted, and the catalog does not change mid-session. */
let cachedRequest = null;

const toOption = (section) => ({ value: section.sectionKey, label: section.name });

/**
 * The Profile filter's options: the dashboard section catalog, flat
 * (`POST /v0/dashboard/dashboard/section/list_filter`). Each option's value is
 * the `sectionKey` that `widget/list` takes as `sectionKeys`.
 *
 * TEMP-FALLBACK: an empty or failed catalog serves `SECTION_FALLBACK_FILTERS` — the same
 * verified sections the dashboards screens fall back to — so the filter is
 * always there to use. A failure is not cached, so the next mount retries.
 */
export const loadProfileFilterOptions = () => {
  if (!cachedRequest) {
    cachedRequest = listSectionFilters()
      // TODO(TEMP-FALLBACK): remove this fallback (or reorganize it) once `section/list_filter` returns real rows.
      .then(({ sections }) => (sections.length ? sections : SECTION_FALLBACK_FILTERS))
      .catch(() => {
        cachedRequest = null;
        // TODO(TEMP-FALLBACK): remove this fallback (or reorganize it) once `section/list_filter` returns real rows.
        return SECTION_FALLBACK_FILTERS;
      })
      .then((sections) => sections.filter((section) => section.sectionKey).map(toOption));
  }
  return cachedRequest;
};

/** Test seam: forget the cached catalog. */
export const resetProfileFilterOptionsCache = () => {
  cachedRequest = null;
};

export const useProfileFilterOptions = () => {
  const [options, setOptions] = useState(EMPTY);

  useEffect(() => {
    let mounted = true;
    loadProfileFilterOptions().then((next) => {
      if (mounted) setOptions(next);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return options;
};

export default useProfileFilterOptions;
